/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DayOfWeek } from "./DayOfWeek";
import {
  DayOfWeekFromJSON,
  DayOfWeekFromJSONTyped,
  DayOfWeekToJSON,
  DayOfWeekToJSONTyped,
} from "./DayOfWeek";
import type { MissingInvoiceComparisonDay } from "./MissingInvoiceComparisonDay";
import {
  MissingInvoiceComparisonDayFromJSON,
  MissingInvoiceComparisonDayFromJSONTyped,
  MissingInvoiceComparisonDayToJSON,
  MissingInvoiceComparisonDayToJSONTyped,
} from "./MissingInvoiceComparisonDay";

/**
 *
 * @export
 * @interface MissingInvoiceStrategy
 */
export interface MissingInvoiceStrategy {
  /**
   *
   * @type {MissingInvoiceComparisonDay}
   * @memberof MissingInvoiceStrategy
   */
  comparisonDay: MissingInvoiceComparisonDay;
  /**
   *
   * @type {number}
   * @memberof MissingInvoiceStrategy
   */
  numberOfDaysToConsiderOverdue: number;
  /**
   *
   * @type {boolean}
   * @memberof MissingInvoiceStrategy
   */
  shouldEmailCarrierToRequestInvoice: boolean;
  /**
   *
   * @type {DayOfWeek}
   * @memberof MissingInvoiceStrategy
   */
  dayOfTheWeek?: DayOfWeek | null;
}

/**
 * Check if a given object implements the MissingInvoiceStrategy interface.
 */
export function instanceOfMissingInvoiceStrategy(
  value: object,
): value is MissingInvoiceStrategy {
  if (!("comparisonDay" in value) || value["comparisonDay"] === undefined)
    return false;
  if (
    !("numberOfDaysToConsiderOverdue" in value) ||
    value["numberOfDaysToConsiderOverdue"] === undefined
  )
    return false;
  if (
    !("shouldEmailCarrierToRequestInvoice" in value) ||
    value["shouldEmailCarrierToRequestInvoice"] === undefined
  )
    return false;
  return true;
}

export function MissingInvoiceStrategyFromJSON(
  json: any,
): MissingInvoiceStrategy {
  return MissingInvoiceStrategyFromJSONTyped(json, false);
}

export function MissingInvoiceStrategyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MissingInvoiceStrategy {
  if (json == null) {
    return json;
  }
  return {
    comparisonDay: MissingInvoiceComparisonDayFromJSON(json["comparisonDay"]),
    numberOfDaysToConsiderOverdue: json["numberOfDaysToConsiderOverdue"],
    shouldEmailCarrierToRequestInvoice:
      json["shouldEmailCarrierToRequestInvoice"],
    dayOfTheWeek:
      json["dayOfTheWeek"] == null
        ? undefined
        : DayOfWeekFromJSON(json["dayOfTheWeek"]),
  };
}

export function MissingInvoiceStrategyToJSON(
  json: any,
): MissingInvoiceStrategy {
  return MissingInvoiceStrategyToJSONTyped(json, false);
}

export function MissingInvoiceStrategyToJSONTyped(
  value?: MissingInvoiceStrategy | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    comparisonDay: MissingInvoiceComparisonDayToJSON(value["comparisonDay"]),
    numberOfDaysToConsiderOverdue: value["numberOfDaysToConsiderOverdue"],
    shouldEmailCarrierToRequestInvoice:
      value["shouldEmailCarrierToRequestInvoice"],
    dayOfTheWeek: DayOfWeekToJSON(value["dayOfTheWeek"]),
  };
}
